import SearchByName from './components/SearchByName'
import './styles.css'

export default function App() {
  return (
    <div className="App">
      <h1>GitHub User Search</h1>
      <SearchByName />
    </div>
  )
}
